import DataTable from 'react-data-table-component';
import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';

const customStyles = {
    headCells: {
        style: {
            fontSize: '12px', // تغییر اندازه فونت برای سرستون‌ها
        },
    }, cells: {
        style: {
            fontSize: '12px', // تغییر اندازه فونت برای سلول‌ها
        },
    },
};

export default class Operations extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'operation',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 10,
            phrase: ''
        };
    }

    componentDidMount() {
        this.refreshData();
    }


    renderForm() {
        console.log(this.state)
        const getOperationTypeDescription = (type) => {
            switch (type) {
                case 0:
                    return 'دریافت';
                case 1:
                    return 'پرداخت';
            }
        }


        const columns = [
            {
                name: 'ردیف',
                selector: (row, index) => this.genRowNumber(index),
                center: true,
                sortable: true,
                width: '100px',
            },
            {
                name: 'نام عملیات',
                selector: row => row.name,
                sortable: true,
            },
            {
                name: 'نوع عملیات',
                selector: row => getOperationTypeDescription(row.transactionType),
                sortable: true,
            },
            {
                name: 'معین حساب',
                selector: row => row.account.title, // استفاده از تابع getAccountTitle
                sortable: true,
            },
            {
                name: 'عملیات',
                cell: row => (
                    <ul className="nk-tb-actions gx-1">
                        <li>
                            <div className="drodown">
                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                <div className="dropdown-menu dropdown-menu-end">
                                    <ul className="link-list-opt no-bdr">
                                        <li><NavLink to={`/operation/edit/${row.id}/`}><em className="icon ni ni-eye"></em><span>مشاهده و ویرایش</span></NavLink></li>
                                        <li><a className="hand" onClick={() => this.confirmRemove(row.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-na"></em><span>حذف رکورد</span></a></li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                center: true,
            },
        ];


        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست عملیات‌ها</h3>
                            <div className="nk-block-des text-soft">
                                <p>شما {this.state.data.recordsCount} عملیات ثبت شده دارید</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a onClick={e => this.getPdfs(e)} className="btn btn-white btn-outline-light"><em className="icon ni ni-file-pdf"></em><span>خروجی PDF</span></a>
                                        </li>
                                        <li>
                                            <a onClick={e => this.getExcels(e)} className="btn btn-white btn-outline-light"><em className="icon ni ni-file-xls"></em><span>خروجی Excel</span></a>
                                        </li>
                                        <li>
                                            <NavLink to="/operation/upload/" className="btn btn-white btn-outline-light"><em className="icon ni ni-download-cloud"></em><span>ورود اکسل اطلاعات</span></NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/operation/new/" className="btn btn-primary"><em className="icon ni ni-download-cloud"></em><span>افزودن عملیات جدید</span></NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner p-0">
                            <DataTable
                                columns={columns}
                                data={this.state.data.records}
                                noHeader
                                highlightOnHover
                                customStyles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmptyAnnualsOrCompanies(this.state.data.global) ? this.renderNoCompanyOrAnnualRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}